import React, { ReactNode, useState } from 'react'
import '../css/Toolbar.css'
import { GiHamburgerMenu } from "react-icons/gi";
import Menu from './Menu';
interface Props{
    hamburguesa: boolean;
    handleHamburguesa:(isActive:boolean)=>void;
    
}
const Toolbar = (props:Props) => {
    const toogleMenu = ()=>{
        if(props.hamburguesa){
            //alert("Abriendo");
        }else{
            //alert("Cerrando")
    }
    props.handleHamburguesa(!props.hamburguesa);
    }
  return (
    <div className='toolbar'>
      <GiHamburgerMenu className='iconoHamburguesa' onClick={toogleMenu}/>
      
    </div>
  )
}
 
export default Toolbar
